












import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import EntitySearchSelect from '@/modules/common/entity-search/components/shared/EntitySearchSelect.vue'
import { ModelSync } from 'vue-property-decorator'
import { AdminRoleRoute } from '@/modules/role/routes/admin-role.route'

@Component({
  components: {
    EntitySearchSelect
  }
})
export default class AdminUserRoleSearch extends Vue {
  constructor(
    private readonly route: AdminRoleRoute
  ) {
    super()
  }

  @ModelSync('value', 'input') role

  protected get roleSearchRoute() {
    return this.route.rolesSearch()
  }
}
